// extracted by mini-css-extract-plugin
export default {"main":"Send_main__-M5VX","To":"Send_To__WGXFb","editor":"Send_editor__aDKzB"};